import { Admin, Resource } from "react-admin";
import "./App.css";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import basicAuthProvider from "./auth/basicAuthProvider";
import { UploadPhotosCreate } from "./components/create/UploadPhotosCreate";
import { UploadPhotosList } from "./components/list/UploadPhotosList";
import configData from "./config.json";
import httpDataProvider from "./data/httpDataProvider";
import httpDataProviderJwt from "./data/httpDataProviderJwt";
import { i18nProvider } from "./i18n/i18nProvider";
import { Layout } from "./layout";
import { lightTheme } from "./layout/themes";
import {
  API_ENDPOINT_PATH,
  FRONT_IMAGES_PATH,
  UploadDocumentsConstants as UDC,
} from "./utils/const";
import { ImageDownloader } from "./components/imageDownloader/ImageDownloader";

const props = configData.OidcAuthentication
  ? { dataProvider: httpDataProviderJwt, layout: Layout }
  : { dataProvider: httpDataProvider, authProvider: basicAuthProvider };

const App = () => (
  <Router>
    <Routes>
      <Route
        path="*"
        element={
          <Admin
            requireAuth
            i18nProvider={i18nProvider}
            theme={lightTheme}
            {...props}
          >
            <Resource
              name={FRONT_IMAGES_PATH}
              list={UploadPhotosList}
              create={UploadPhotosCreate}
              options={{ label: UDC.title }}
            />
          </Admin>
        }
      />
      <Route path={`/${API_ENDPOINT_PATH}/:id`} element={<ImageDownloader />} />
    </Routes>
  </Router>
);

export default App;
